export default {
  methods: {
    setToken(token) {
      localStorage.setItem('token', token);
    },
    getToken() {
      return localStorage.getItem('token');
    },
    clearToken() {
      localStorage.removeItem('token');
    },
    userLoggedIn() {
      return localStorage.getItem('token') != null;
    },
    userHasRole(role) {
      const userRoles = localStorage.getItem("roles");

      if (userRoles == null) {

        window.location.href = window.location.origin;

      }
      const decryptedRoles = atob(userRoles).split(",");
      const roles = Array.isArray(decryptedRoles) ? decryptedRoles : [decryptedRoles];
      if (role == null || role == "") return true;

      return roles.indexOf(role) > -1;
    }
  }
};
